import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-burger',
  templateUrl: './icon-burger.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconBurgerComponent {}
